import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  width: 100%;
`;

export const EmptyRow = styled.div`
  padding: 32px 16px;
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.body.size};
  text-align: center;
`;

export const LoadingRow = styled.div`
  padding: 32px 16px;
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.body.size};
  text-align: center;
`;
